// @ts-nocheck

import React from 'react'
import styled from 'styled-components'
import ChartLine from './ChartLine'
import {LoadingLayer} from "../../LoadingLayer";
import {CustomDatePicker} from "./CustomDatePicker"

export type ChartTypes = {
    className?: string,
    title?: string,
    sortBar?: {
        options: Array<{
            selected: any
            id: string, label: any
        }>,
        onClick: (id: string) => void
    },
    graph?: any,
    formatX?: (any) => string,
    formatY?: (any) => string,
    loading?: any,
    onDateChange: any,
    date: any
}

function Chart(props: ChartTypes) {
    return (
        <StyledChart className={props.className}>
            {props.loading && <LoadingLayer/>}

            <div className='header'>
                <div className='title'>{props.title}</div>
                <div className='sort-bar'>
                    <CustomDatePicker date={props.date} onChange={props.onDateChange}/>
                    {
                        props
                            ?.sortBar
                            ?.options
                            ?.map(
                                item => (
                                    <StyledOption
                                        className='option'
                                        key={item.label + item.id}
                                        selected={item.selected}
                                        onClick={_ => props.sortBar?.onClick(item.id)}>
                                        {item.label}
                                    </StyledOption>
                                )
                            )
                    }
                </div>
            </div>
            <ChartLine
                formatX={props.formatX}
                formatY={props.formatY}
                graph={props.graph} className={'chartLine'}/>
        </StyledChart>
    )
}


const StyledChart = styled.div`
  font-family: "Open Sans";
  border-radius: 15px;
  height: 378px;
  width: 100%;
  background: white;
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  position: relative;


  .header {
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 11111;

    .title {
      font-size: 26px;
      font-weight: bold;
      margin-left: 41px;
    }

    .sort-bar {
      display: flex;
      margin-right: 20px;
    }
  }

  .chartLine {
    height: 70%;
  }

`

const StyledOption = styled.div`
  margin-left: 20px;
  cursor: pointer;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    height: ${p => p.selected ? '4px' : '0'};
    background: #0659C1;
    bottom: -4px;
    left: -2px;
    right: -2px;
    border-radius: 1px;

  }`
export default Chart